import { hasActivePaidAccess, normalizeSubscriptionType } from './subscriptionAccess';

export const needsOnboarding = (profile) => {
  if (!profile) return false;
  if (profile.onboarding_completed) return false;
  const subscriptionType = normalizeSubscriptionType(profile);
  if (!subscriptionType) return true;
  return !hasActivePaidAccess(profile);
};

export const getPostAuthRedirect = ({ profile, intendedRoute }) => {
  if (profile && needsOnboarding(profile)) {
    return {
      redirectTo: '/onboarding',
      reason: 'needs_onboarding',
      preserveIntendedRoute: true
    };
  }

  if (intendedRoute) {
    return {
      redirectTo: intendedRoute,
      reason: 'intended_route',
      preserveIntendedRoute: false
    };
  }

  return {
    redirectTo: '/',
    reason: 'default_route',
    preserveIntendedRoute: false
  };
};
